var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60517 25.602C6.60517 26.1914 6.80317 26.69 7.19917 27.098C7.59517 27.506 8.09017 27.7214 8.68417 27.744H12.8422C13.4142 27.744 13.9092 27.5287 14.3272 27.098C14.7452 26.6674 14.9432 26.1687 14.9212 25.602V8.43203C14.9212 7.8427 14.7232 7.3327 14.3272 6.90203C13.9312 6.47136 13.4362 6.26736 12.8422 6.29003H8.68417C8.11217 6.29003 7.61717 6.49403 7.19917 6.90203C6.78117 7.31003 6.58317 7.82003 6.60517 8.43203V25.602ZM19.0792 25.602C19.0792 26.1914 19.2882 26.69 19.7062 27.098C20.1242 27.506 20.6082 27.7214 21.1582 27.744H25.3162C25.8882 27.744 26.3832 27.5287 26.8012 27.098C27.2192 26.6674 27.4172 26.1687 27.3952 25.602V8.43203C27.3952 7.8427 27.1972 7.3327 26.8012 6.90203C26.4052 6.47136 25.9102 6.26736 25.3162 6.29003H21.1582C20.5862 6.29003 20.1022 6.49403 19.7062 6.90203C19.3102 7.31003 19.1012 7.82003 19.0792 8.43203V25.602Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/PauseIcon.36028f651f198d734cb13bdea77ae324.svg";
export { ForwardRef as ReactComponent };